import { Injectable } from '@angular/core';
import { DataService } from '../Common/data.service';

@Injectable({
  providedIn: 'root'
})
export class ServiceRequestService {
  constructor(private _data: DataService) { }

  AddServiceRequest = (data: any): any => {
    return this._data.PostData('ServiceRequest/SaveServiceRequest', data);
  }
  UploadServiceRequestAttachment = (formData): any => {
    return this._data.PostData('ServiceRequest/UploadServiceRequestAttachment', formData);
  }
  GetServiceRequestDetailByID = (ID: string): any => {
    return this._data.GetDataById('ServiceRequest/GetServiceRequestByID', ID);
  }
  GetAllServiceRequest = (data: any): any => {
    return this._data.PostData('ServiceRequest/GetAllServiceRequest', data);
  }
  GetMailTemplateForSR = (ID: string, SRNumber: String, MailTemplateName: string): any => {

    return this._data.PostData('ServiceRequest/GetMailTemplateForSR', { RequestEntityId: ID, MailTemplateName: MailTemplateName, SRNumber: SRNumber });
  }
  SaveServiceRequestLogDetail = (data: any): any => {
    return this._data.PostData('ServiceRequest/SaveServiceRequestLogDetail', data);
  }
  UpdateServiceRequest = (data: any): any => {
    return this._data.PostData('ServiceRequest/UpdateServiceRequestDetail', data);
  }
  GetAssigmentToEmployee(url, param1, param2) {
    return this._data.PostData(url, { Param1: param1, Param2: param2 });
  }
  SaveFilterDetail = (data: any): any => {
    return this._data.PostData('ServiceRequest/SaveFilterDetail', data);
  }
  GetUserWiseFilterDetail = (data: any): any => {
    return this._data.PostData('ServiceRequest/GetUserWiseFilterDetail', data);
  }
  ExportData = (data: any): any => {
    return this._data.DownloadFileWithPost('ServiceRequest/SRReportExportToExcel', data);
  }
}
